import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7cd36236&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7cd36236&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd36236",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cd36236')) {
      api.createRecord('7cd36236', component.options)
    } else {
      api.reload('7cd36236', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7cd36236&scoped=true", function () {
      api.rerender('7cd36236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/refund/index.vue"
export default component.exports